module.exports = __webpack_public_path__ + "static/media/mito22.0754f99d.jpg";